import {useEffect, useState} from "react"

export const useIsOnClient = () => {
    const [isOnClient, setIsOnClient] = useState(false)

    useEffect(() => {
        // ading a startTransition to the useEffect because there are multiple tiles on a page
        // window.requestIdleCallback(() => {
        setIsOnClient(true)
        // })
    }, [])

    return {isOnClient}
}
